import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal, Row, Col, Button, Table, Stack, Badge } from "react-bootstrap";
import { get_facturas, get_factura_by_id } from "../../services/contratos";
import { CiWarning } from "react-icons/ci";
import { MdDownload } from "react-icons/md";

function GestionFacturas({ contrato, show, close, handleClose, onClose }) {
  const [loading, setLoading] = useState(false);
  const [facturas, setfacturas] = useState(false);

  const estados = {
    open: { descrip: "EMITIDA", bg: "primary" },
    cancel: { descrip: "CANCELADA", bg: "danger" },
    paid: { descrip: "PAGADA", bg: "success" },
    proforma2: { descrip: "PROFORMA", bg: "danger" },
    impagada: { descrip: "IMPAGADA", bg: "danger" },
  };

  useEffect(() => {
    if (show && contrato) {
      const getfacturas = async () => {
        setLoading(true);
        setfacturas(await get_facturas(contrato.name, contrato.sector_type));
        setLoading(false);
      };
      getfacturas();
    }
  }, [show, contrato]);

  const closeModal = () => {
    if (typeof handleClose === "function") {
      handleClose();
      return;
    }

    if (typeof close === "function") {
      close(false);
    }
  };

  const cerrar = () => {
    closeModal();
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const stateBadge = (state) => {
    return (
      <Badge pill bg={estados[state].bg}>
        {estados[state].descrip}
      </Badge>
    );
  };

  const descargarfactura = async (invoice_id) => {
    try {
      const factura = await get_factura_by_id(invoice_id, contrato.sector_type);
      let pdfWindow = window.open("");
      pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        encodeURI(factura) +
        "'></iframe>"
      );
      pdfWindow.document.title = "AB Energía - Agentes";
    } catch (error) { }
  };

  const getfacturas = async () => {
    if (!contrato) return;
    setLoading(true);
    setfacturas(await get_facturas(contrato.polissa_name, contrato.sector_type));
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={cerrar}
      size="lg"
      backdrop="static"
      centered
      contentClassName="border-0 rounded-4 shadow-lg"
    >
      <Modal.Header className="bg-white border-bottom-0" closeButton>
        <div className="d-flex flex-column">
          <Modal.Title className="fw-bold text-primary">Gestión de Facturas</Modal.Title>
          <span className="text-muted small">Nº {contrato?.name || ''}</span>
        </div>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="p-3">
          {loading ? (
            <div
              style={{ height: "40vh" }}
              className="d-flex flex-column justify-content-center align-items-center text-muted"
            >
              <div className="spinner-border text-primary mb-3" role="status"></div>
              <h5 className="fw-bold">Cargando facturas...</h5>
            </div>
          ) : facturas ? (
            <div
              style={{ height: "40vh", overflowY: "auto" }}
              className="rounded-3 border border-light shadow-sm"
            >
              <Table
                striped
                hover
                borderless
                className="mb-0"
              >
                <thead className="bg-light sticky-top">
                  <tr>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Factura</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Fecha</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Importe</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase">Estado</th>
                    <th className="py-3 px-4 text-muted small fw-bold text-uppercase text-end">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {facturas &&
                    facturas.map((factura) => {
                      return (
                        <tr key={factura.id} className="align-middle">
                          <td className="px-4 py-3 text-secondary fw-bold">{factura.number}</td>
                          <td className="px-4 py-3 text-muted">{factura.date_invoice}</td>
                          <td className="px-4 py-3 text-secondary fw-bold">{factura.amount_total} €</td>
                          <td className="px-4 py-3">{stateBadge(factura.state)}</td>
                          <td className="px-4 py-3 text-end">
                            <div className="d-flex justify-content-end">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="rounded-circle p-2 d-flex align-items-center justify-content-center"
                                title="Descargar factura"
                                style={{ width: '32px', height: '32px' }}
                                onClick={() => descargarfactura(factura.id)}
                              >
                                <MdDownload />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          ) : (
            <div style={{ height: "40vh" }} className="d-flex flex-column justify-content-center align-items-center text-center opacity-75">
              <CiWarning className="display-1 text-muted mb-3" />
              <h4 className="text-muted fw-bold mb-3">No hay facturas disponibles.</h4>
              <Button
                className="rounded-pill px-4 fw-bold shadow-sm"
                variant="primary"
                onClick={() => getfacturas()}
              >
                Reintentar
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0 pb-4">
        <Button
          className="rounded-pill px-4"
          variant="secondary"
          onClick={cerrar}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default connect()(GestionFacturas);
